export const currentDate = new Date(new Date().setHours(24, 0, 0, 0))

export const daysOfWeek = [
  'segunda-feira',
  'terça-feira',
  'quarta-feira',
  'quinta-feira',
  'sexta-feira',
  'sabado',
  'domingo'
] as const

export const quantityOfDaysInWeek: number = daysOfWeek.length
